export default __webpack_public_path__ + "static/media/1376.ec1de336.png";